import API_BASE_URL from "../../../../../Constants";


const createContract = async (contract) => {

    const response = await fetch(API_BASE_URL + '/api/maintenance/maintenance-contracts', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        credentials: 'include',
        body: JSON.stringify(contract),
    });

    return await response.json();

}

const updateContract = async (contract) => {

    const response = await fetch(`${API_BASE_URL}/api/maintenance/maintenance-contracts/${contract.contractId}`, {
        method: 'PUT',
        headers: {
            'Content-Type': 'application/json',
        },
        credentials: 'include',
        body: JSON.stringify(contract),
    });

    return await response.json();

}

const deleteContract = async (contractId) => {

    const response = await fetch(`${API_BASE_URL}/api/maintenance/maintenance-contracts/${contractId}`, {
        method: 'DELETE',
        credentials: 'include',
    });

    if (response.ok) {
        return await response.text();
    }
    else {
        throw Error(await response.text());
    }



}

const getAllContracts = async () => {

    const response = await fetch(`${API_BASE_URL}/api/maintenance/maintenance-contracts/all`, {
        method: 'GET',
        credentials: 'include',
    });

    return await response.json();

}


export {
    createContract,
    updateContract,
    deleteContract,
    getAllContracts,
};